import { render } from "./SurveyDetails.vue?vue&type=template&id=5d8a9604"
import script from "./SurveyDetails.vue?vue&type=script&lang=js"
export * from "./SurveyDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__